import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\GetPaymentByDossierIdController::__invoke
* @see app/Http/Controllers/Dossier/GetPaymentByDossierIdController.php
* @route '/api/dossier/{dossier}/payment/{payment}'
*/
const GetPaymentByDossierIdController = (args: { dossier: string | number | { id: string | number }, payment: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, payment: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPaymentByDossierIdController.url(args, options),
    method: 'get',
})

GetPaymentByDossierIdController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/payment/{payment}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\GetPaymentByDossierIdController::__invoke
* @see app/Http/Controllers/Dossier/GetPaymentByDossierIdController.php
* @route '/api/dossier/{dossier}/payment/{payment}'
*/
GetPaymentByDossierIdController.url = (args: { dossier: string | number | { id: string | number }, payment: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, payment: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            payment: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        payment: typeof args.payment === 'object'
        ? args.payment.id
        : args.payment,
    }

    return GetPaymentByDossierIdController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{payment}', parsedArgs.payment.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\GetPaymentByDossierIdController::__invoke
* @see app/Http/Controllers/Dossier/GetPaymentByDossierIdController.php
* @route '/api/dossier/{dossier}/payment/{payment}'
*/
GetPaymentByDossierIdController.get = (args: { dossier: string | number | { id: string | number }, payment: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, payment: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPaymentByDossierIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\GetPaymentByDossierIdController::__invoke
* @see app/Http/Controllers/Dossier/GetPaymentByDossierIdController.php
* @route '/api/dossier/{dossier}/payment/{payment}'
*/
GetPaymentByDossierIdController.head = (args: { dossier: string | number | { id: string | number }, payment: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, payment: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetPaymentByDossierIdController.url(args, options),
    method: 'head',
})

export default GetPaymentByDossierIdController